// Servicio para solicitudes de REMOCIÓN de funciones
import { http_client } from "@/plugins/http_client";

const url = "/api/v1/funcion";
const solicitudUrl = url + "/remover-funciones";
const catalogoUrl = url + "/catalogo";
const urlPresupuesto = "/api/v1/presupuesto";

const getListadoSolicitudes = async (id_tab, params = {}) =>
  await http_client(`${solicitudUrl}/${id_tab}`, params, "get");

const getEstadosSolicitud = async (idTab) =>
  await http_client(`${url}/catalogo/estados/${idTab}`, {}, "get");

const getPerfilesTabsSolicitud = async () =>
  await http_client(`${solicitudUrl}/switch-tabs`, {}, "get");

const getDetalleSolicitud = async (id, params = {}) =>
  await http_client(`${solicitudUrl}/detalle/${id}`, params, "get");

const getDetalleEmpleadoPorDocumento = async (numeroDocumento) =>
  await http_client(`${solicitudUrl}/detalle-empleado/${numeroDocumento}`, {}, "get");

const getDetalleBannerEmpleado = async (idEmpleadoPuesto) =>
  await http_client(`${solicitudUrl}/detalle-banner-empleado`, { id_empleado_puesto: idEmpleadoPuesto }, "get");

const getFuncionesAsignadasRemover = async (idEmpleadoPuesto) =>
  await http_client(`${solicitudUrl}/funciones-asignadas/${idEmpleadoPuesto}`, {}, "get");

const postCrearSolicitud = async (params) =>
  await http_client(`${url}/remover/crear`, params, "post");

const getDescargarDocumento = async (id) =>
  await http_client(`${url}/remover/descargar/${id}`, {}, "get", {
    responseType: "blob",
  });

const getVerDocumentoAcuerdo = async (id_solicitud, firmado) =>
  await http_client(`${url}/acuerdos/ver-documento-acuerdo`, { id_solicitud, firmado }, "get");

const getExpedientesEmpleados = async (params = {}) =>
  await http_client(`${url}/expedientes-empleados`, params, "get");

const getCatalogoTipoDocumento = async () =>
  await http_client(`${catalogoUrl}/tipo-documento`, {}, "get");

const getCatalogoFuncionesPorEmpleadoPuesto = async (idEmpleadoPuesto) =>
  await http_client(`${catalogoUrl}/funcion/${idEmpleadoPuesto}`, {}, "get");

const getCatalogoTiposCompensacion = async () =>
  await http_client(`${catalogoUrl}/tipo-compensacion`, {}, "get");

const postEnviarSolicitudFunciones = async (params) =>
  await http_client(`${solicitudUrl}/enviar`, params, "post");

const putActualizarSolicitudFunciones = async (idSolicitud, params) =>
  await http_client(`${solicitudUrl}/${idSolicitud}`, params, "put");

const postActualizarEstadoSolicitud = async (idSolicitud, params) =>
  await http_client(`${solicitudUrl}/movimiento-solicitud/${idSolicitud}`, params, "post");

const getBannerSeguimiento = async (idSolicitud) =>
  await http_client(`${solicitudUrl}/banner-seguimiento/${idSolicitud}`, {}, "get");

const getBitacora = async (idSolicitud, params = {}) =>
  await http_client(`${solicitudUrl}/bitacora/${idSolicitud}`, params, "get");

const postGuardarComprobanteSolicitud = async (idSolicitud, documento) => {
  const formData = new FormData();
  formData.append('documento', documento);

  return http_client(
    `${solicitudUrl}/comprobante/${idSolicitud}`,
    formData,
    "post",
    { "Content-Type": "multipart/form-data" }
  );
};

const postGenerarDocumentoAcuerdo = async (idSolicitud) =>
  await http_client(`${url}/remover/acuerdos/generar-documento-acuerdo`, { id_solicitud: idSolicitud }, "post");

const postFirmarDocumentoAcuerdo = async (idSolicitud) =>
  await http_client(`${url}/remover/acuerdos/firmar-documento-acuerdo`, { id_solicitud: idSolicitud }, "post");

export default {
  getListadoSolicitudes,
  getEstadosSolicitud,
  getPerfilesTabsSolicitud,
  getDetalleSolicitud,
  getDetalleEmpleadoPorDocumento,
  getDetalleBannerEmpleado,
  getFuncionesAsignadasRemover,
  postCrearSolicitud,
  getDescargarDocumento,
  getVerDocumentoAcuerdo,
  getExpedientesEmpleados,
  getCatalogoFuncionesPorEmpleadoPuesto,
  getCatalogoTiposCompensacion,
  postEnviarSolicitudFunciones,
  putActualizarSolicitudFunciones,
  postActualizarEstadoSolicitud,
  getBannerSeguimiento,
  getBitacora,
  getCatalogoTipoDocumento,
  getExpedientesEmpleados,
  postGuardarComprobanteSolicitud,
  postGenerarDocumentoAcuerdo,
  postFirmarDocumentoAcuerdo,
};
